export const LICENSE_ADMIN_OPTIONS = [
  "inn",
  "branchCode",
  "organization",
  "year",
  "actionType",
  "status",
  "decision",
  "comment",
  "createdAt",
  "updatedAt",
  "author",
  "decisionUser",
] as const;
